import { UAParser } from 'ua-parser-js';
import { computed, ref } from 'vue';

// https://docs.uaparser.dev/api/ua-parser-js/overview.html
export const useUserAgent = () => {
  const userAgent = ref(UAParser());

  const isIosOs = computed(() => userAgent.value.os.name === 'iOS');
  const isAndroidOs = computed(() => userAgent.value.os.name === 'Android');
  const isMobileChromeBrowser = computed(() => userAgent.value.browser.name === 'Mobile Chrome');
  const isMobileFirefoxBrowser = computed(() => userAgent.value.browser.name === 'Mobile Firefox');
  const isMobileSafariBrowser = computed(() => userAgent.value.browser.name === 'Mobile Safari');
  const isMobileOrTabletDevice = computed(() =>
    ['mobile', 'tablet'].includes(userAgent.value.device.type)
  );

  return {
    userAgent,
    isMobileOrTabletDevice,
    isIosOs,
    isAndroidOs,
    isMobileChromeBrowser,
    isMobileFirefoxBrowser,
    isMobileSafariBrowser,
  };
};
